module.exports = __webpack_public_path__ + "static/media/s1.8e49a828.webp";